import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { RootState } from '../reducers';
import { useSelector } from 'react-redux';
import { fetchneeddata, viewdata } from '../reduxactions/donorrsactions/DUrgentReduxAction';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';

const UrgentNeeds = () => {
    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchneeddata(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])
    const data = useSelector((state: RootState) => state.durgentreducer.data);
    const dataview = useSelector((state: RootState) => state.durgentreducer.dataview);

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }


    //data from table 
    const viewupload = (rowData: any) => {
        assignData.current = { Id: rowData.Id }
        setfield(true);
        fetchDataAsyncdialog();

    };
    const assignData = useRef({ Id: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { Id } = assignData.current;
            console.log("ids", Id)
            dispatch(viewdata(uid, Id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donor-urgentneeds.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Urgent Needs</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Urgent Needs</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* <section className="content"> */}
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>
                                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="nameoftheorg" sortable header="Organization "></Column>
                                        <Column field="needtype" sortable header="Need"></Column>
                                        <Column header="Operations" body={(rowData) => (
                                            <>
                                                {/* <Button icon="pi pi-eye" rounded outlined tooltip="View" onClick={() => viewupload(rowData)} style={{ backgroundColor: 'white', color: 'blue' }} /> */}
                                                <GFNButton icon="pi pi-eye" data-testid={`view-btn-${rowData.Id}`} rounded outlined onClick={() => viewupload(rowData)} buttonType="primary" />
                                            </>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Panel>
                        {/* </section> */}
                        <Dialog header="Details" visible={acceptfield} onHide={cancelfield}>
                            <div className='grid pt-3'>
                            </div>
                            <form className="form-horizontal" action="" method="POST">
                                {dataview.map((response: any) =>

                                    <div className="col-12" style={{ width: '20vw', height: '30vh' }}>
                                        <div className="grid pt-3"></div>
                                        <div className="row">
                                            <div className="grid pt-2">
                                                <div className="col-7" >
                                                    Need  :
                                                </div>
                                                <div className="col md-3" >
                                                    {response.needtype}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='grid pt-3' ></div>
                                        <div className="row">
                                            <div className="grid pt-2">
                                                <div className="col-7" >
                                                    Organization :
                                                </div>
                                                <div className='col md-4'>
                                                    {response.nameoftheorg}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='grid pt-3'></div>
                                    </div>
                                )}
                            </form>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UrgentNeeds
